var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMermaidLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7772_1060)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8572 0H4.14281C1.8548 0 0 1.8548 0 4.14281V19.8572C0 22.1452 1.8548 24 4.14281 24H19.8572C22.1452 24 24 22.1452 24 19.8572V4.14281C24 1.8548 22.1452 0 19.8572 0Z",
    fill: "#FF3670"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9517 5.44368C18.2318 5.37007 16.5332 5.8471 15.1031 6.80538C13.673 7.76366 12.5859 9.1532 12 10.7719C11.4141 9.1532 10.327 7.76366 8.89687 6.80538C7.46676 5.8471 5.76823 5.37007 4.04832 5.44368C3.99057 6.81917 4.28421 8.1867 4.90154 9.41724C5.51886 10.6478 6.43952 11.7007 7.57663 12.4768C8.16001 12.8775 8.63678 13.4145 8.96555 14.0412C9.29432 14.668 9.46514 15.3655 9.4632 16.0732V18.5635H14.5373V16.0732C14.5353 15.3655 14.706 14.668 15.0347 14.0413C15.3634 13.4145 15.8401 12.8775 16.4234 12.4768C17.5608 11.701 18.4817 10.6481 19.099 9.41752C19.7164 8.18691 20.0099 6.81923 19.9517 5.44368Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.86503 16.0733C7.86741 15.6258 7.76039 15.1844 7.55328 14.7877C7.34617 14.391 7.04524 14.0509 6.67668 13.797C6.1758 13.4552 5.70795 13.0673 5.27926 12.6385C4.81571 12.174 4.40079 11.6635 4.04097 11.1147V18.5636H7.86503V16.0733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.135 16.0733C16.1326 15.6258 16.2396 15.1844 16.4467 14.7877C16.6538 14.391 16.9548 14.0509 17.3233 13.797C17.8242 13.4552 18.292 13.0673 18.7207 12.6385C19.1843 12.174 19.5992 11.6635 19.959 11.1147V18.5636H16.135V16.0733Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7772_1060"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMermaidLogo);
export default __webpack_public_path__ + "static/media/mermaid-logo.7ebbe37e39165a7ff0765c63dd559047.svg";
export { ForwardRef as ReactComponent };